/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommissionRate = {
    rate: number;
    shopId: string;
    feature: CommissionRate.feature;
    id?: string;
    createdAt?: string;
    updatedAt?: string;
};
export namespace CommissionRate {
    export enum feature {
        CHECK_IMEI = 'CHECK_IMEI',
        CHECK_SLIP = 'CHECK_SLIP',
    }
}

